import { AuthContext } from "contexts/AuthContext";
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { emailValidations as validations } from "utils/validations/loginValidations";
import useForm from "hooks/useForm";
import Container from "components/Library/Container";
import Form from "components/Library/Form";
import Button from "components/Library/Button";
import Input from "components/Library/Input";

function ForgotPassword() {
  const authContext = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [formValues, handleInputChange, errors, setErrors] = useForm({
    email: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const formErrors = validations(formValues);
    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      authContext.forgotPassword(formValues.email);
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    setErrors(authContext.errorMessage);
    setLoading(false);
  }, [setErrors, authContext.errorMessage]);

  return (
    <Container>
      <Form className="form form--sm" onSubmit={handleSubmit}>
        <h1 className="form__title">Recuperar contraseña</h1>
        <Input
          type="email"
          placeholder="Correo electrónico"
          name="email"
          value={formValues.email}
          error={errors.email}
          onChange={handleInputChange}
        />
        <div className="form__buttons">
          <Link className="button button--secondary" to="/">
            Regresar
          </Link>
          <Button type="submit" value="Continuar" disabled={loading} />
        </div>
      </Form>
    </Container>
  );
}

export default ForgotPassword;
